
import { CourseCard } from "./CourseCard"
import { Card, Box, Typography } from '@mui/material';
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { processFetchingDashboardDetails } from "../../redux-store/dashboardSlice/dashboardSliceActions";
import { selectAllCourses } from "../../redux-store/dashboardSlice/dashboardSliceSelectors"; // selector from adapter

const courseColors = [
    { color: "rgb(231,179,11)", btnBgColor: "rgba(231,179,11,0.2)" },
    { color: "#ef5350", btnBgColor: "rgba(239,83,80,0.2)" },
    { color: "#29b6f6", btnBgColor: "rgba(41,182,246,0.2)" },
    { color: "purple", btnBgColor: "rgba(128,0,128,0.2)" },
    { color: "orange", btnBgColor: "rgba(255,165,0,0.2)" },
    { color: "#66bb6a", btnBgColor: "rgba(102,187,106,0.2)" },
    { color: "#ab47bc", btnBgColor: "rgba(171,71,188,0.2)" }
];


export const PopularCourses = ({ onCourseClick, selectedCourseId  }) => {
    const dispatch = useDispatch();
    const courses = useSelector(selectAllCourses); // get courses from Redux store
    // console.log("Courses from Redux:", courses);

    useEffect(() => {
        dispatch(processFetchingDashboardDetails());
    }, [dispatch]);


    // ✅ Sort + limit
    const sortedCourses = [...courses]
        .filter(c => c?.courseName)
        .sort((a, b) => b.courseID - a.courseID);


    return (
        <Card sx={{ height: 460, display: "flex", flexDirection: "column"}}>
            <Box p={2} display="flex" flexDirection="column" height="100%">

                <Typography variant="h6" fontWeight="600" textAlign="center" sx={{ mb: 1 }}>
                    Currently Active Courses
                </Typography>


                {/* Scrollable container with fixed height */}
                <Box
                    mt={1}
                    sx={{
                        flexGrow: 1,          // ✅ takes remaining space
                        overflowY: "auto",    // ✅ scroll inside
                        pr: 1
                    }}
                >
                    {sortedCourses.map((c, index) => {
                        const name = c.courseName || "";
                        const colorSet = courseColors[index % courseColors.length];

                        return (
                            <Box
                                key={c.courseID}
                                onClick={() => onCourseClick && onCourseClick(c.courseID)} // ✅ ADD THIS
                                sx={{ 
                                    cursor: "pointer",
                                    border: selectedCourseId === c.courseID ? "2px solid red" : "none"
                                 }} // optional (nice UX)
                               
                            >
                                <CourseCard
                                    key={c.courseID}
                                    mediaText={name.charAt(0)}
                                    mediaColor={colorSet.color}
                                    title={name}
                                    subtitle={`1+ Courses`}
                                    btnBgColor={colorSet.btnBgColor}
                                />
                            </Box>
                        );
                    })}
                </Box>
            </Box>
        </Card>
    );
};